// extracted by mini-css-extract-plugin
module.exports = {"resizer":"speakerNotes_resizer__2FVdg","speakerNotesContainer":"speakerNotes_speakerNotesContainer__3VxD9"};